/**
 * 我的资产（数据库版）
 * GET/POST/DELETE /asset_library
 */

import api from '@/utils/api'

function unwrapList(res) {
  if (res == null) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.list)) return res.list
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && typeof d === 'object') {
    if (Array.isArray(d.list)) return d.list
    if (Array.isArray(d.data)) return d.data
    if (d.data && typeof d.data === 'object' && Array.isArray(d.data.list)) return d.data.list
  }
  return []
}

function assertApiOk(res) {
  if (res == null || typeof res !== 'object') return
  const c = res.code
  if (c === undefined || c === null) return
  const n = Number(c)
  if (n === 0 || n === 200) return
  const msg = res.message || res.msg || res.error || `接口 code=${c}`
  throw new Error(msg)
}

export async function fetchAssetLibraryList(opts) {
  const params = {
    limit: opts?.limit ?? 60,
    ...(opts?.kind ? { kind: opts.kind } : {}),
    ...(opts?.q ? { q: opts.q } : {})
  }
  const res = await api.get('/asset_library', { params })
  assertApiOk(res)
  return unwrapList(res)
}

export async function addAssetsToLibrary(items) {
  const list = Array.isArray(items) ? items : []
  const res = await api.post('/asset_library', { items: list })
  assertApiOk(res)
  return res
}

export async function deleteAssetFromLibrary(id) {
  const rid = String(id || '').trim()
  if (!rid) throw new Error('缺少 id')
  const res = await api.delete(`/asset_library/${encodeURIComponent(rid)}`)
  assertApiOk(res)
  return res
}

